import { FC, useEffect, ReactNode } from "react"
import moment from "moment-timezone"
import { useGetCompanyCurrencyPublicQuery } from "../generated/graphql"

type TimezoneBootstrapProps = {
    children: ReactNode
}

/**
 * Setzt die globale moment-timezone Default-Zeitzone basierend auf den Backend-Settings.
 * Muss innerhalb von ApolloWrapper gerendert werden.
 */
const TimezoneBootstrap: FC<TimezoneBootstrapProps> = ({ children }) => {
    const { data } = useGetCompanyCurrencyPublicQuery()

    useEffect(() => {
        const timezone = data?.companyCurrencyPublic?.timezone
        if (timezone) {
            moment.tz.setDefault(timezone)
        }
    }, [data?.companyCurrencyPublic?.timezone])

    return <>{children}</>
}

export default TimezoneBootstrap
